export default "__VITE_ASSET__421af4cf__"